import { useParams } from "react-router-dom";
import Container from '@mui/material/Container';
import CommunityHeader from "./CommunityHeader";
import * as React from "react";
import {useEffect} from "react";

const CommunityContext = React.createContext({communityId:undefined});

const CommunityDetail = ({ token, setShowNav }) => {

    const {id} = useParams();
    useEffect(() => {
        setShowNav(true);
    }, [])

    return (
        <CommunityContext.Provider value={{communityId:id}}>
            <Container className={'container'}>
                <CommunityHeader token={token} id={id} setShowNav={setShowNav}/>
            </Container>
        </CommunityContext.Provider>
    );
};

export default CommunityDetail;

export {CommunityContext}
